export default __webpack_public_path__ + "static/media/r8.2b809fac.png";